import { Link } from 'react-router-dom';
import { Camera, GearSix } from '@phosphor-icons/react';

import { CyclePeriodSettings } from '../../components/cycle/CyclePeriodSettings';
import { SectionSkeleton } from '../../components/common/SectionSkeleton';
import pt from '../../locales/pt';
import { paths } from '../../routes/paths';
import { useSelfieCycle } from '../../store/SelfieCycleContext';

export function CycleSettings() {
  const { currentCycle, cycles, isLoading } = useSelfieCycle();

  return (
    <div className="flex flex-col gap-5 md:gap-6">
      <header className="hidden md:block min-w-0">
        <h1 className="flex items-center gap-2 font-display text-xl font-semibold text-foreground md:text-2xl">
          <GearSix className="h-5 w-5 shrink-0 text-sage-600" aria-hidden />
          {pt.cycleSettings.title}
        </h1>
        <p className="mt-1 text-xs text-muted-foreground md:text-sm">{pt.cycleSettings.subtitle}</p>
      </header>

      <section className="app-panel gap-3 border-border bg-card">
        {isLoading && !currentCycle ? (
          <SectionSkeleton variant="hero" className="min-h-[8rem] border-0 bg-transparent p-0" />
        ) : currentCycle ? (
          <CyclePeriodSettings cycle={currentCycle} />
        ) : cycles.length === 0 ? (
          <p className="text-sm text-muted-foreground">{pt.cycleSettings.currentCycle.noCycleYet}</p>
        ) : (
          <p className="text-sm text-muted-foreground">{pt.cycleSettings.currentCycle.readOnlyHint}</p>
        )}
      </section>

      <Link
        to={paths.selfies}
        className="flex items-center gap-2 rounded-xl border border-border bg-card px-3 py-2.5 text-sm font-medium text-sage-800 transition-colors hover:bg-muted"
      >
        <Camera className="h-4 w-4 shrink-0" aria-hidden />
        {pt.cycleSettings.selfiesLink}
      </Link>
    </div>
  );
}

export default CycleSettings;
